/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManagedTeamMetaContract
 */
export interface ManagedTeamMetaContract {
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamMetaContract
     */
    creator?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ManagedTeamMetaContract
     */
    creationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamMetaContract
     */
    description?: string | null;
}

/**
 * Check if a given object implements the ManagedTeamMetaContract interface.
 */
export function instanceOfManagedTeamMetaContract(value: object): value is ManagedTeamMetaContract {
    return true;
}

export function ManagedTeamMetaContractFromJSON(json: any): ManagedTeamMetaContract {
    return ManagedTeamMetaContractFromJSONTyped(json, false);
}

export function ManagedTeamMetaContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagedTeamMetaContract {
    if (json == null) {
        return json;
    }
    return {
        
        'creator': json['creator'] == null ? undefined : json['creator'],
        'creationDate': json['creationDate'] == null ? undefined : (new Date(json['creationDate'])),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ManagedTeamMetaContractToJSON(json: any): ManagedTeamMetaContract {
    return ManagedTeamMetaContractToJSONTyped(json, false);
}

export function ManagedTeamMetaContractToJSONTyped(value?: ManagedTeamMetaContract | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creator': value['creator'],
        'creationDate': value['creationDate'] == null ? value['creationDate'] : value['creationDate'].toISOString(),
        'description': value['description'],
    };
}

